export const validation = {
  maxTitleChar: 200,
  maxParagraphChar: 3000
}
